import styled from 'styled-components'
import { device } from 'Styled/variables'

export const TopbarComponent = styled.div`
  width: 100%;
  height: 60px;
  z-index: 201;
  box-shadow: 0 2px 15px 0 rgb(0 0 0 / 5%);
  background: #000;
  display: flex;
  align-items: center;
  padding-left: 16px;
  @media ${device.mobileMin} {
    padding-left: 0px;
  }
`

export const Logo = styled.div`
  height: 32px;
  width: 149px;
`

export const CreateCampaignBlock = styled.div`
  width: 100%;
  max-width: 816px;
  margin: auto;
`
